import { INITIALIZE_SOCKET, WITHOUT_INIT_SOCKET } from "../constants";

export const setInializeSocket = (payload) => ({
    type: INITIALIZE_SOCKET,
    payload,
});

export const withOutInitSocket = (payload) => ({
    type: WITHOUT_INIT_SOCKET,
    payload,
});